module.exports = __webpack_public_path__ + "img/progress.138e225b.png";